import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
export default class ContentSlider {
    constructor() {
        this.slider = document.querySelector('.swiper--content-slider');
        this.navigationPrev = document.querySelector('.slider-button-prev--content-slider');
        this.navigationNext = document.querySelector('.slider-button-next--content-slider');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
            },
        });
    }
}
if (document.querySelector('.swiper--content-slider')) {
    new ContentSlider();
}
